'use client';

import { EmblaCarouselType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import { Children, ComponentPropsWithoutRef, useEffect, useRef, useState } from 'react';
import { cn } from '@/shared/lib/cn';
import './recommended-products-carousel.scss';

type Props = ComponentPropsWithoutRef<'div'>;
export const RecommendedProductsCarousel = ({ children, ...props }: Props) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [slidesInView, setSlidesInView] = useState<number[]>([]);

    const isActive = slidesInView.length !== Children.count(children);

    const [emblaRef, emblaApi] = useEmblaCarousel({
        slidesToScroll: 1,
        direction: 'ltr',
        align: 'start',
        watchDrag: isActive,
        inViewThreshold: 0.9,
    });

    useEffect(() => {
        if (!emblaApi) return;
        const update = (emblaApi: EmblaCarouselType) => {
            setSlidesInView(emblaApi.slidesInView());
        };
        emblaApi.on('slidesInView', update);
        return () => {
            emblaApi.off('slidesInView', update);
        };
    }, [emblaApi]);
    return (
        <div
            ref={emblaRef}
            className={cn('recommended-products-carousel', props.className)}
            data-active={isActive}
        >
            <div ref={containerRef} className="recommended-products-carousel__container">
                {children}
            </div>
        </div>
    );
};
